const SUPPORT_REQUEST = 'SUPPORT_REQUEST'
const SUPPORT_SUCCESS = 'SUPPORT_SUCCESS'
const SUPPORT_FAILURE = 'SUPPORT_FAILURE'
const SUPPORT_SET_ACTIVE = 'SUPPORT_SET_ACTIVE'

export default {
  SUPPORT_REQUEST,
  SUPPORT_SUCCESS,
  SUPPORT_FAILURE,
  SUPPORT_SET_ACTIVE,
}
